'use client'

import * as React from 'react'

import { ScrollFadeOverlay } from './ScrollFadeOverlay'
import { useScrollFade } from './useScrollFade'
import { cn } from '../lib/cn'

export interface ScrollFadeContainerProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'children'> {
  children: React.ReactNode
  gradientFrom?: string
  horizontal?: boolean
  vertical?: boolean
  /** Fade depth: `'default'` = 16px, `'lg'` = 32px (e.g. for large data tables). */
  size?: 'default' | 'lg'
}

export const ScrollFadeContainer = React.forwardRef<HTMLDivElement, ScrollFadeContainerProps>(
  ({ children, className, gradientFrom, horizontal, vertical, size, ...props }, ref) => {
    const { canScrollLeft, canScrollRight, canScrollTop, canScrollBottom, scrollRef } = useScrollFade()

    React.useImperativeHandle(ref, () => scrollRef.current!)

    return (
      <div className='relative flex-1 min-h-0 min-w-0'>
        <ScrollFadeOverlay
          canScrollLeft={horizontal ? canScrollLeft : undefined}
          canScrollRight={horizontal ? canScrollRight : undefined}
          canScrollTop={vertical ? canScrollTop : undefined}
          canScrollBottom={vertical ? canScrollBottom : undefined}
          gradientFrom={gradientFrom}
          size={size}
        />
        <div ref={scrollRef} className={cn('overflow-auto h-full', className)} {...props}>
          {children}
        </div>
      </div>
    )
  },
)
ScrollFadeContainer.displayName = 'ScrollFadeContainer'
